import LectureLessonHistoryListResourcePagingResultModel from '../../generated/types/model/resource/LectureLessonHistoryListResourcePagingResultModel';

export default class LectureLessonHistoryListResourcePagingResultViewModel extends LectureLessonHistoryListResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
